interface Props {
  children: React.ReactNode;
  additionalStyles?: React.CSSProperties;
}

const ThemeLine = ({ children, additionalStyles = {} }: Props) => (
  <div style={{ marginTop: "-5px" }}>
    <span
      style={{
        fontStyle: "italic",
        fontWeight: 600,
        color: "#D91266",
        ...additionalStyles,
      }}
    >
      {children}
    </span>
  </div>
);

export default ThemeLine;
